import React, { Component } from "react";
import styles from "./routeTripsContent.module.scss";
import { withRoutes } from "../../../shared/containers/containerRoutes";
import Icon from "../../../shared/items/static/icon";
import Scrollbars from "react-custom-scrollbars-2";
import ModalConfirmWindow from "../ModalComponents/ModalConfirmWindow";
import DeleteButton from "../../DeleteButton/DeleteButton";
import DeleteConfirm from "../ModalComponents/DeleteConfirm";
import { states } from "../../../reducers/queriesStates";
import { NavLink } from "react-router-dom";

class RouteTripsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpenModalConfirm: false,
    };
  }

  componentDidUpdate(prevPeops) {
    const { selectedTripId, selectedRouteId, deleteRouteTripDataState } = this.props;

    if (prevPeops.selectedRouteId !== selectedRouteId || prevPeops.selectedTripId !== selectedTripId) {
      this.setState({ isOpenModalConfirm: false });
    }

    if (prevPeops.deleteRouteTripDataState === states.REQUEST && deleteRouteTripDataState === states.READY) {
      this.setState({ isOpenModalConfirm: false });
    }
  }

  onSelectHandle(trip) {
    const { onSelectTrip } = this.props;
    onSelectTrip(trip);
  }

  onUnselectHandle(e) {
    const { onUnselectTrip } = this.props;
    onUnselectTrip();
  }

  onOpenDeleteClick() {
    this.setState({ isOpenModalConfirm: true });
  }

  onNotDeleteConfirm() {
    this.setState({ isOpenModalConfirm: false });
  }

  onDeleteConfirm() {
    const { onDeleteTrip, selectedTripId, selectedRouteId } = this.props;
    onDeleteTrip({ id: selectedTripId }, selectedRouteId);
  }

  render() {
    const { trips, selectedTripId, selectedRouteId } = this.props;
    const { isOpenModalConfirm } = this.state;

    return (
      <div className={styles.routeTripsListContainer}>
        <Scrollbars style={{ height: "450px" }} autoHide={true} ref="scrollbar">
          {trips.map((trip) => {
            const unitTitle = trip.unit !== null ? `${trip.unit.title} ${trip.unit.registerNumber}` : "ТС не назначено";

            return (
              <div
                key={trip.id}
                className={styles.routeTripsListItem}
                onClick={(e) => {
                  e.stopPropagation();
                  this.onSelectHandle(trip);
                }}
              >
                <NavLink
                  to={`/routes/${selectedRouteId}/trips/${trip.id}`}
                  className={styles.navigationItem}
                  activeClassName={styles.navigationItem_active}
                >
                  <div
                    className={styles.routeTripTile}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <div>{trip.start}</div> <div>-</div> <div>{trip.end}</div>
                    <div>{unitTitle}</div>
                    {selectedTripId === trip.id ? (
                      <NavLink
                        to={`/routes/${selectedRouteId}/trips`}
                        className={styles.navigationItem}
                        activeClassName={styles.navigationItem_active}
                      >
                        <div
                          className={styles.routeTripsListItemCloseBtn}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.onUnselectHandle();
                          }}
                        >
                          <Icon name="x" />
                        </div>
                      </NavLink>
                    ) : null}
                  </div>
                </NavLink>

                {selectedTripId === trip.id ? (
                  <div>
                    <DeleteButton text={"Удалить рейс"} tooltipText={"Удалить рейс"} handleClick={this.onOpenDeleteClick.bind(this)} />
                    {isOpenModalConfirm ? (
                      <ModalConfirmWindow isOpen={isOpenModalConfirm}>
                        <DeleteConfirm
                          onConfirmHandle={this.onDeleteConfirm.bind(this)}
                          onNotConfirmHandle={this.onNotDeleteConfirm.bind(this)}
                          text={`Удалить рейс ${trip.start} - ${trip.end} (${unitTitle})?`}
                        />
                      </ModalConfirmWindow>
                    ) : null}
                  </div>
                ) : null}
              </div>
            );
          })}
        </Scrollbars>
      </div>
    );
  }
}

export default withRoutes(React.memo(RouteTripsList));
